import { useContext, useEffect, useMemo, useRef, useState } from "react"
import _ from "underscore";
import { ToastContext } from "../../../context/ToastContext";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { callautopopulate } from "../../../services/callautopop";
import { calculateWordsFromString } from "../../../utils/Helper";

export const useGitRequest = ({ projectOpts, setShowRequestPopup, callApi, editData, setEditData }) => {
    const tagRef = useRef();
    const { showInfo, showError, showSuccess } = useContext(ToastContext)
    const [popupFilters, setPopupFilters] = useState({ type: {}, project: {}, repo: [], role: {}, approve_by: 0, reason: "", git_request_id: 0, create_request_type: 0, git_group: {}, repo_name: "", group_name: "" });
    const [spin, setSpin] = useState();
    const [options, setOptions] = useState({});
    const [previousData, setPreviousData] = useState({ type: {}, project: {}, repo: [], role: {}, approve_by: 0, reason: "", git_request_id: 0, create_request_type: 0, git_group: {}, repo_name: "" });

    useEffect(() => {
        if (editData !== undefined && editData !== null) {
            const project = _.findWhere(projectOpts, { project_id: editData?.project_id });
            const repoGroup = _.findWhere(options?.gitGroups, { repo_group_id: editData?.repo_group_id });
            setPopupFilters((prev) => ({ ...prev, reason: editData?.reason, project: project, git_request_id: editData?.git_request_id, approve_by: editData?.approver_user_code, create_request_type: editData?.is_new_repo ? 1 : 0, repo_name: editData?.repo_name }));
            setPreviousData((prev) => ({ ...prev, reason: editData?.reason, project: project, git_request_id: editData?.git_request_id, approve_by: editData?.approver_user_code, create_request_type: editData?.is_new_repo ? 1 : 0, git_group: repoGroup, repo_name: editData?.repo_name }));
        }
    }, [editData])

    useEffect(() => {
        callautopopulate("request_types").then((res) => {
            setOptions((prev) => ({
                ...prev,
                request_type: res?.request_types
            }))
        })
    }, [])

    // submit new request created
    const handleRequestSubmit = async () => {
        try {
            if (_.isEmpty(popupFilters?.project)) {
                showInfo("info", "Please select project");
                return;
            }

            if (popupFilters?.create_request_type === 1) {
                if (_.isEmpty(popupFilters?.git_group)) {
                    showInfo("info", "Please select a git group");
                    return;
                } else if (popupFilters?.repo_name?.length === 0) {
                    showInfo("info", "Please enter repo name");
                    return;
                }
            } else {
                if (_.isEmpty(popupFilters?.repo)) {
                    showInfo("info", "Please select a git repo");
                    return;
                } else if (_.isEmpty(popupFilters?.role)) {
                    showInfo("info", "Please select role");
                    return;
                }
            }

            if (popupFilters?.approve_by === 0) {
                showInfo("info", "Please select an approver");
                return;
            } else if (calculateWordsFromString(popupFilters.reason) < 5) {
                showInfo("info", "Reason should contain minimum 5 words");
                return;
            } else if (_.isEqual(previousData, popupFilters)) {
                showInfo("info", "No changes made!")
            } else {
                setSpin(true)
                const payload = {
                    "git_request_id": popupFilters?.git_request_id !== undefined ? parseInt(popupFilters?.git_request_id) : 0,
                    "repo_ids": popupFilters?.create_request_type === 0 ? _.pluck(popupFilters?.repo, "repo_id").toString() : "",
                    "request_role_type_id": popupFilters?.create_request_type === 0 ? parseInt(popupFilters?.role?.request_type_roles_id) : options?.roleDetails?.[0]?.request_type_roles_id,
                    "request_to": parseInt(popupFilters?.approve_by),
                    "reason": popupFilters?.reason,
                    "is_new_repo": parseInt(popupFilters?.create_request_type),
                    "repo_group_id": popupFilters?.create_request_type === 0 ? 0 : parseInt(popupFilters?.git_group?.repo_group_id !== undefined ? (!_.isEmpty(editData) && popupFilters?.git_group?.repo_group_name?.toLowerCase()?.trim() === "new group") ? 0 : popupFilters?.git_group?.repo_group_id : 0),
                    "project_id": parseInt(popupFilters?.project?.project_id),
                    "repo_name": popupFilters?.create_request_type === 0 ? "" : popupFilters?.repo_name,
                    "repo_group_name": !_.isEmpty(editData) && popupFilters?.group_name
                }
                const res = await services.getInvokeRemote("POST", Urls("SENDGITREQUEST"), payload);
                if (res) {
                    if (res?.body?.StatusCode === 400 || res?.body?.StatusCode === 204 || res?.body?.StatusCode === 202 || res?.body?.StatusCode === 401 || res?.body?.StatusCode === 500) {
                        showError("error", res?.body?.errorMessage);
                        setSpin(false);
                        return;
                    } else {
                        setSpin(false);
                        showSuccess("success", res?.body?.message);
                        setShowRequestPopup(false);
                        setEditData({})
                        callApi()
                    }
                }
            }
        } catch (error) {
            setSpin(false);
            showError('Error', error?.response?.data?.errorMessage);
            console.error("Error:", error);
        }
    }


    useEffect(() => {
        if (!_.isEmpty(popupFilters.project)) {
            getProjectRepos();
        }
    }, [popupFilters.project, popupFilters.create_request_type]);

    useEffect(() => {
        options?.request_type?.length > 0 && getRequestTypeRole();
    }, [options?.request_type])

    // get repo details project wise while creating new request
    const getProjectRepos = async () => {
        try {
            const payload = {
                project_id: popupFilters.project?.project_id,
                is_new_repo: popupFilters?.create_request_type === 1 ? true : false
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTREPOS"), payload)
            if (res) {
                const approveByData = res?.body?.data?.approve_by;
                const repoDetailsData = res?.body?.data?.repo_details;
                if (popupFilters?.create_request_type === 1) {
                    setOptions((prev) => ({
                        ...prev,
                        gitGroups: repoDetailsData,
                        approveBy: approveByData
                    }))
                    const data = _.findWhere(repoDetailsData, { repo_group_id: editData?.repo_group_id });
                    const groupName = data?.repo_group_name?.toLowerCase()?.trim() === "new group" ? "new group" : "";
                    setPopupFilters((prev) => ({ ...prev, git_group: data, group_name: groupName }))
                } else {
                    setOptions((prev) => ({
                        ...prev,
                        repoDetails: repoDetailsData,
                        approveBy: approveByData
                    }))
                }
                if (_.isEmpty(editData)) {
                    setPopupFilters((prev) => ({ ...prev, repo: [] }));
                    setPopupFilters((prev) => ({ ...prev, approve_by: 0 }));
                } else {
                    const repoIds = _.find(repoDetailsData, { repo_id: editData?.repo_id });
                    setPopupFilters((prev) => ({ ...prev, repo: [repoIds] }));
                    setPreviousData((prev) => ({ ...prev, repo: [repoIds] }));
                }
            }
        } catch (error) {
            console.error("Error:", error);
        }
    }

    // get roles for dropdown
    const getRequestTypeRole = async () => {
        try {
            const payload = {
                request_type_ids: _.findWhere(options?.request_type, { request_type_key: "git_tab" })?.request_type_id
            }
            const res = await services.getInvokeRemote("POST", Urls("GETREQUESTTYPEROLE"), payload);
            if (res) {
                const roleData = _.sortBy(res?.body?.data?.git_roles, "request_role_name");
                setOptions((prev) => ({
                    ...prev,
                    roleDetails: roleData
                }))
                if (_.isEmpty(editData)) {
                    setPopupFilters((prev) => ({ ...prev, role: roleData?.[0], repo: [] }));
                } else {
                    const role = _.findWhere(roleData, { request_type_roles_id: editData?.requested_type_role_id });
                    setPopupFilters((prev) => ({ ...prev, role: role }));
                    setPreviousData((prev) => ({ ...prev, role: role }));
                }
            }
        } catch (error) {
            console.error("Error getting request type roles: ", error);
        }
    };
    return useMemo(() => ({
        popupFilters, setPopupFilters, tagRef, handleRequestSubmit, spin, getProjectRepos, options
    }), [popupFilters, setPopupFilters, tagRef, handleRequestSubmit, spin, getProjectRepos, options])
} 